<label
  [class]="settings.labelClasses"
  [attr.for]="control().name">
  {{ control().label }}
</label>

<textarea
  [class]="settings.inputClasses"
  [id]="control().name"
  [name]="control().name"
  [formControlName]="control().name"
  [placeholder]="placeholder()"
  rows="4"></textarea>

<div [class]="settings.validationFeedbackClasses">
  <ng-container
    validatorMessage
    [helpMessage]="control().helpText"
    [controlName]="control().name" />
</div>
